exports.components = {
  "component---retourenmanager-pages-404-tsx": () => import("./../../../retourenmanager/pages/404.tsx" /* webpackChunkName: "component---retourenmanager-pages-404-tsx" */),
  "component---retourenmanager-pages-index-tsx": () => import("./../../../retourenmanager/pages/index.tsx" /* webpackChunkName: "component---retourenmanager-pages-index-tsx" */),
  "component---retourenmanager-pages-search-tsx": () => import("./../../../retourenmanager/pages/search.tsx" /* webpackChunkName: "component---retourenmanager-pages-search-tsx" */)
}

